module.exports = __webpack_public_path__ + "static/media/vf_wouter_core.8e8c76f6.svg";